import React, { useState } from "react";
import { HelpCircle, X } from "lucide-react";

export default function HelpOverlay() {
  // Do not force the briefing open on every page refresh.
  // Players can open it any time from the persistent ? Help button.
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        data-testid="btn-help"
        onClick={() => setOpen(true)}
        className="absolute bottom-3 left-3 z-20 pointer-events-auto w-10 h-10 flex items-center justify-center border border-white/20 bg-[#0A0C10]/90 backdrop-blur text-white hover:border-cyan-400 hover:text-cyan-400"
      >
        <HelpCircle size={16} />
      </button>
      {open && (
        <div className="absolute inset-0 z-40 pointer-events-auto flex items-center justify-center bg-black/60 backdrop-blur-sm" data-testid="help-modal">
          <div
            className="bg-[#0A0C10] border border-white/10 p-6 max-w-lg w-[92vw]"
            style={{ fontFamily: "Rajdhani, sans-serif" }}
          >
            <div className="flex items-start justify-between mb-4">
              <div>
                <div className="text-[10px] font-mono uppercase tracking-widest text-[#D85C31]">Sol 1 · Briefing</div>
                <div className="text-2xl font-bold uppercase tracking-wide text-white">Mars Colony: First Settlement</div>
              </div>
              <button data-testid="btn-help-close" onClick={() => setOpen(false)} className="text-slate-400 hover:text-white">
                <X size={18} />
              </button>
            </div>
            <div className="space-y-3 text-sm font-mono text-slate-300 leading-relaxed">
              <p>
                Commander, you have landed at your assigned coordinates. Establish a self-sufficient outpost and keep
                <span className="text-cyan-400"> 12 colonists </span> alive across
                <span className="text-cyan-400"> 5 sols </span> of stable life support.
              </p>
              <div>
                <div className="text-[10px] uppercase tracking-widest text-slate-400 mb-1">Controls</div>
                <ul className="space-y-1 text-xs">
                  <li><span className="text-cyan-400">Left-drag</span> pan · <span className="text-cyan-400">Right-drag</span> orbit · <span className="text-cyan-400">Wheel</span> zoom</li>
                  <li><span className="text-cyan-400">Click</span> a building card, then click the terrain to place</li>
                  <li><span className="text-cyan-400">Click</span> a building in the world to select it</li>
                  <li><span className="text-cyan-400">Esc</span> cancel placement · <span className="text-cyan-400">Space</span> pause · <span className="text-cyan-400">1/2/3</span> game speed</li>
                </ul>
              </div>
              <div>
                <div className="text-[10px] uppercase tracking-widest text-slate-400 mb-1">First Steps</div>
                <ol className="list-decimal list-inside space-y-1 text-xs">
                  <li>Build a Solar Power Station and Battery Storage</li>
                  <li>Survey the terrain to locate Hydrated Mineral Zones and metal geology</li>
                  <li>Place a Regolith Water Extractor directly on a Hydrated Mineral Zone</li>
                  <li>Store Raw Water, purify it into Clean Water, then build oxygen production</li>
                  <li>Use an Atmospheric Water Harvester as a low-output emergency backup if needed</li>
                  <li>Build a Habitat then Request Colonists</li>
                </ol>
              </div>
            </div>
            <button
              data-testid="btn-help-start"
              onClick={() => setOpen(false)}
              className="mt-6 w-full py-2 border border-cyan-400 bg-cyan-500/10 hover:bg-cyan-500/20 text-cyan-400 text-xs font-mono uppercase tracking-widest"
            >
              Begin Colony
            </button>
          </div>
        </div>
      )}
    </>
  );
}
